import { Box, Modal as MuiModal, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import "./style.scss";

interface Props {
  title?: string;
  children: React.ReactNode | Array<React.ReactNode>;
  onClose: () => void;
  open: boolean;
}

const Modal = ({
  title = "Expense Module",
  open,
  onClose,
  children,
}: Props) => (
  <MuiModal id="modal-container" open={open} onClose={onClose}>
    <Box className="content-container">
      <Box className="header">
        <Typography variant="h5">{title}</Typography>
        <Close className="close-icon" onClick={onClose} />
      </Box>
      {children}
    </Box>
  </MuiModal>
);

export default Modal;
